import useOmsenApiClient from "./clients/useOmsenApiClient";
import { useQuery } from "@tanstack/react-query";

export default function useOmsenEnabled() {
  const client = useOmsenApiClient();

  const getOmsenEnabled = async () => {
    const response = await client.apiOmsenEnabledGet();
    return response.data;
  };

  return useQuery(["omsenEnabled"], getOmsenEnabled, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
